module.exports = __webpack_public_path__ + "img/file_xlsx.292b62b5.svg";